import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { LabContext } from "../../context/labContext";
import AnimateLoader from "../AnimateLoader";
import YouTube from "react-youtube";
import { motion } from "framer-motion";
import { BtnPrev } from "./Next";

const SingleLab = () => {

    const { id } = useParams();
    const { getLabById } = useContext(LabContext);
    const [lab, setLab] = useState(null);

    useEffect(() => {
        getLabById(id)
            .then(data => {
                setLab(data);
            })
            .catch(() => {
                setLab(false)
            })
    }, [id]);

    if (lab === null) {
        return <AnimateLoader />;
    }

    const opts = {
        height: "100%",
        width: "100%",
        playerVars: {
            autoplay: 0
        }
    };

    return (

        <>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}

                className="h-100 w-100 d-flex flex-column justify-content-between" >
                <div className="d-flex justify-content-between align-items-center">
                    <div className="col-md-12">
                        <h1>{lab.title}</h1>
                        <div className="ratio ratio-16x9">
                            <YouTube videoId={lab.url} opts={opts} loading={<AnimateLoader />} />
                        </div>
                        <div className="fs-3 mt-3">
                            About this lab
                        </div>

                    </div>
                </div>
                <div className="mt-3 my-5" >
                    {lab.description}
                </div>

            </motion.div>
        </>
    )
}

export default SingleLab;